import { ClassData } from '@models/class-data';
import { EventConfirmationPageCardType } from '@models/events/enums/event-confirmation-page-card-type.enum';
import { EventShareOptions } from './event-share-options.model';

export class EventConfirmationPageCard {
  id: number;
  eventId: number;
  type: EventConfirmationPageCardType;
  title?: string;
  description?: string;
  ctaText?: string;
  hidden?: boolean;

  shareOptions?: EventShareOptions;

  constructor(json: ClassData<EventConfirmationPageCard>) {
    this.id = +json.id;
    this.eventId = json.eventId;
    this.type = json.type;
    this.title = json.title;
    this.description = json.description;
    this.ctaText = json.ctaText;
    this.hidden = json.hidden;

    if (json.shareOptions) {
      this.shareOptions = json.shareOptions;
    }
  }
}
